<template>
  <div>
    <!-- 上方为右侧导航条部分 -->
    <div class="E_flex_box E_flex_right_box">
      <div class="E_flex_box_bg">
        <a
          v-for="(item, index) in sidebarList"
          :key="index"
          :href="item.link"
          class="E_flex_item_box"
        >
          <div class="E_flex_item_img">
            <img class="E_flex_item_img_active" :src="item.image" alt="" />
            <img class="E_flex_item_img_pto" :src="item.image_hover" alt="" />
          </div>
          <div class="E_flex_item_title">{{ item.name }}</div>
        </a>
        <!-- 固定区域 -->
        <a href="javascript:;" class="E_flex_item_box E_kefu_tips_parent">
          <div class="E_flex_item_img">
            <img
              class="E_flex_item_img_active"
              src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/product/icon/E_cust_active.png"
              alt=""
            />
            <img
              class="E_flex_item_img_pto"
              src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/product/icon/E_cust.png"
              alt=""
            />
          </div>
          <div class="E_flex_item_title">网校客服</div>
          <!-- 客服悬浮框 -->
          <div class="E_kefu_tips_box E_kefu_tips_bottom">
            <div class="E_kefu_tips_box_img">
              <img
                src="https://upload.5kjs.com/upload/agency_wechat/20220421/e7a22ef3f3156d3c9cc06f67792bf554.png"
                alt=""
              />
            </div>
            <P class="E_kefu_tips_box_title"> 扫码添加客服 </P>
          </div>
        </a>
        <a href="/buycard " class="E_flex_item_box">
          <div class="E_flex_item_img">
            <img
              class="E_flex_item_img_active"
              src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/product/icon/E_shopp_active.png"
              alt=""
            />
            <img
              class="E_flex_item_img_pto"
              src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/product/icon/E_shopp.png"
              alt=""
            />
          </div>
          <div class="E_flex_item_title">购物车</div>
        </a>
        <a
          href="javascript:;"
          @click="openSuggest()"
          class="E_flex_item_box E_Suggest_btn"
        >
          <div class="E_flex_item_img">
            <img
              class="E_flex_item_img_active"
              src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/product/icon/E_opin_active.png"
              alt=""
            />
            <img
              class="E_flex_item_img_pto"
              src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/product/icon/E_opin.png"
              alt=""
            />
          </div>
          <div class="E_flex_item_title">反馈意见</div>
        </a>
      </div>
      <div class="E_backTop_box E_flex_box_bg" @click="backTop()">
        <div class="E_flex_item_box">
          <div class="E_flex_item_img">
            <i class="iconfont icon-jiantou1"></i>
          </div>
          <div class="E_flex_item_title">回到顶部</div>
        </div>
      </div>
    </div>
    <!-- 下方为意见反馈框部分 -->
    <div class="E_suggest_box" @click="closeSuggest" :style="suggestFlag">
      <div class="E_suggest" @click.stop>
        <p class="E_suggest_title">意见建议</p>
        <div class="E_suggest_content_box">
          <textarea
            class="E_suggest_txt"
            name=""
            id=""
            placeholder="请尽量详细描述您遇到的问题，有助于我们快速给到您反馈。"
            v-model="suggestionsContent"
          ></textarea>

          <div class="E_suggest_txt_Box">
            <input
              type="file"
              class="E_suggest_updateImg_btn"
              accept="image/png, image/jpeg"
              @change="fileChange()"
              ref="imgFile"
            />
            <div class="E_suggest_imgBoxs">
              <div
                class="E_suggest_imgBox E_suggest_updateImg_btn_box"
                @click="AddImg()"
              >
                <i class="iconfont icon-tupian1"></i>
              </div>
              <div
                v-for="(item, index) in baseImg"
                :key="index"
                class="E_suggest_imgBox E_suggest_updateImg"
                @click="removeImg(index)"
              >
                <img :src="item" alt="" />
                <i class="E_suggest_updateImg_closer iconfont icon-yuancha"></i>
              </div>
            </div>
            <span class="E_suggest_imgNum">
              <span class="E_suggest_imgNum_box">{{ baseImg.length }}</span>
              / 9(图片大小请控制在2M以内)</span
            >
          </div>
        </div>
        <p class="E_suggest_title E_suggest_link_method">联系方式</p>
        <input
          type="text"
          class="E_suggest_link_method_input"
          placeholder="请填写邮箱或者手机号，以便我们为你提供更好的服务"
          v-model="contact"
        />
        <div class="E_suggest_tips">
          遇到困难，使用
          <div class="E_suggest_kefu E_kefu_tips_parent">
            在线客服
            <!-- 客服悬浮框 -->
            <div class="E_kefu_tips_box E_kefu_tips_top">
              <div class="E_kefu_tips_box_img">
                <img
                  src="https://upload.5kjs.com/upload/agency_wechat/20220421/e7a22ef3f3156d3c9cc06f67792bf554.png"
                  alt=""
                />
              </div>
              <P class="E_kefu_tips_box_title"> 扫码添加客服 </P>
            </div>
          </div>
          ，也可拨打400-0057-228进行反馈。
        </div>
        <div class="E_suggest_bottom_btn_box">
          <div class="E_suggest_bottom_btn" @click="updateSuggest()">提交</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入意见反馈弹框

export default {
  data() {
    return {
      sidebarList: null,
      //   意见反馈弹框控制器
      suggestFlag: "",
      //   base64预览数组
      baseImg: [],
      //   二进制上传数组
      suggestUpDateImg: [],
      //   问题描述
      suggestionsContent: "",
      //   联系方式
      contact: "",
    };
  },
  mounted() {
    this.getsidebar();
  },
  methods: {
    // 请求数据
    getsidebar() {
      let origin = window.location.origin;
      origin =
        origin == "http://localhost:8080" ? "http://hnjszp.xueba.hk" : origin;
      this.$axios
        .post(`${origin}/sidebar`)
        .then((res) => {
          console.log(res.side_right);
          this.sidebarList = res.side_right;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 返回顶部
    backTop() {
      this.$("html").animate(
        {
          scrollTop: 0,
        },
        300
      );
    },
    // 打开意见反馈
    openSuggest() {
      this.suggestFlag = "display:flex";
    },
    // 关闭意见反馈
    closeSuggest() {
      this.suggestFlag = "";
    },
    // 触发图片添加
    AddImg() {
      if (this.baseImg.length < 9) {
        this.$refs.imgFile.click();
      } else {
        this.$message("最多只能添加9张图片噢~");
      }
    },
    // 图片添加操作
    fileChange() {
      let event = event || window.event;
      let file = event.target.files[0];
      let reader = new FileReader();
      let that = this;
      //转base64
      reader.onload = function (e) {
        that.baseImg.push(e.target.result);
        console.log(that.baseImg);
      };
      this.suggestUpDateImg.push(file);
      reader.readAsDataURL(file);
    },
    // 图片的删除操作
    removeImg(index) {
      this.baseImg.splice(index, 1);
      this.suggestUpDateImg.splice(index, 1);
    },
    // 反馈意见上传
    updateSuggest() {
      let ISlogin = localStorage.getItem("token");
      if (ISlogin == null) {
        // 未登录则跳转登录
        let nowUrl = window.location.href;
        nowUrl = nowUrl.replace(/#/g, "vue");
        let url = window.location.origin;
        if (sessionStorage.getItem("distrid") != null) {
          window.location.href =
            url +
            "/login?turn_jump_url=" +
            nowUrl +
            "&distrid=" +
            sessionStorage.getItem("distrid");
        } else {
          window.location.href = url + "/login?turn_jump_url=" + nowUrl;
        }
      }

      if (this.suggestionsContent.trim().length == 0) {
        this.$message("您还没有填写反馈意见");
        return;
      }

      if (this.contact.trim().length == 0) {
        this.$message("您还没有填写联系方式");
        return;
      }

      let origin = window.location.origin;
      origin =
        origin == "http://localhost:8080" ? "http://hnjszp.xueba.hk" : origin;

      let formdata = new FormData();
      formdata.append("suggestions", this.suggestionsContent);
      formdata.append("contact", this.contact);
      formdata.append("token", localStorage.getItem("token"));
      formdata.append("pagelink",window.location.href)
      this.suggestUpDateImg.forEach((item) => {
        formdata.append("files[]", item);
      });

      this.$axios
        .post(`${origin}/suggestions`, formdata)
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.$message({
              message: "反馈成功，感谢您宝贵的建议~",
              type: "success",
            });
            // 反馈成功之后初始化参数并关闭弹框
            this.contact = "";
            this.suggestionsContent = "";
            this.suggestUpDateImg = [];
            this.baseImg = [];
            this.closeSuggest();
          } else {
            this.$message({
              message: "网络错误，请稍后再试，或者联系客服",
              type: "warning",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.flexStyle(@direction, @item, @justify) {
  display: flex;
  flex-direction: @direction;
  align-items: @item;
  justify-content: @justify;
}
// 侧边悬浮栏开始
@media (max-width: 1770px) {
  .E_flex_box {
    display: none;
  }
}

// 左侧边栏部分
.E_flex_box {
  z-index: 999;
  // transition: all .5s ease;
  position: fixed;
  top: 35rem;
  right: 12%;
  padding: 0.5rem;
  width: 4.625rem;
  height: auto;

  .E_flex_box_bg {
    box-shadow: 0px 0px 9px 0px rgb(0 0 0 / 6%);
    background: #ffffff;
  }

  .E_flex_item_box {
    padding: 0.625rem 0;
    display: inline-block;
    width: 100%;

    .E_flex_item_img {
      height: 1.5625rem;
      .flexStyle(row, center, center);

      .E_flex_item_img_pto {
        display: none;
      }

      img {
        height: 100%;
        max-width: 100%;
      }
    }

    .E_flex_item_title {
      text-align: center;
      margin-top: 0.5625rem;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #7a7f8d;
    }
  }

  .E_flex_item_box:hover {
    background-color: #f22322;

    .E_flex_item_img_active {
      display: none;
    }

    .E_flex_item_img_pto {
      display: block;
    }

    .E_flex_item_title {
      color: #fff;
    }

    .iconfont::before {
      color: #fff;
    }
  }
}

.E_flex_left_box {
  box-sizing: content-box;
  left: 0;
  top: 35rem;
  padding-right: 4.375rem;
  transform: translateX(-100%);
}

.E_flex_right_box {
  box-sizing: content-box;
  padding-left: 4.375rem;
  // right: 0;
  transform: translateX(100%);

  .E_backTop_box {
    cursor: pointer;
    margin-top: 0.75rem;
    font-size: 1.875rem;
    color: #2e3642;

    .E_flex_item_title {
      margin-top: 0;
    }
  }
}

// 客服弹框
.E_kefu_tips_parent {
  position: relative;
  cursor: pointer;

  .E_kefu_tips_box {
    border: 1px solid #eee;
    position: absolute;
    z-index: 999;
    top: 0;
    left: 50%;
    width: 11.5rem;
    min-height: 11.5rem;
    color: #666;
    font-size: 0.75rem;
    text-align: center;
    background-color: #fff;
    box-shadow: 0 2px 0.625rem #aaa;
    transition: all 200ms;
    border-radius: 0.3125rem;
    transform: translate(-50%, -100%);
    .flexStyle(column,center,center);
    display: none;

    .E_kefu_tips_box_img {
      width: 8.5625rem;
      height: 8.5625rem;
      margin: 0.625rem auto;

      img {
        max-width: 100%;
        height: 100%;
      }
    }
    .E_kefu_tips_box_title {
      margin: 5px 0;
    }
  }

  .E_kefu_tips_box::after {
    content: "";
    position: absolute;
    left: 50%;
    margin-left: -0.375rem;
    bottom: -0.8125rem;
    width: 0;
    height: 0;
    border-width: 0.5rem 0.375rem 0.375rem 0.375rem;
    border-style: solid;
    border-color: #fff transparent transparent transparent;
  }

  // 悬浮在上方（默认）
  .E_kefu_tips_top {
    top: 0;
    left: 50%;
    transform: translate(-50%, -100%);
  }

  // 悬浮在下方
  .E_kefu_tips_bottom {
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 35%);
  }

  .E_kefu_tips_bottom::after {
    left: 50%;
    margin-left: -0.375rem;
    top: -0.8125rem;
    border-color: transparent transparent #fff transparent;
  }
}

.E_kefu_tips_parent:hover {
  .E_kefu_tips_box {
    display: flex;
  }
}

// 意见建议弹框样式
.E_suggest_box {
  z-index: 1000;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  .flexStyle(row, center, center);
  display: none;
  .E_suggest {
    padding: 2.0625rem;
    width: 54.125rem;
    height: 33.0625rem;
    background: #f6f7fb;
    border-radius: 0.625rem;

    .E_suggest_title {
      font-size: 1.125rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }

    // 意见图片框
    .E_suggest_content_box {
      margin-top: 1.1875rem;

      .E_suggest_txt {
        outline: none;
        padding: 1.125rem;
        box-sizing: border-box;
        width: 100%;
        height: 8.75rem;
        background: #ffffff;
        border: 1px solid #dddddd;
        border-radius: 0.3125rem;
        resize: none;
      }

      .E_suggest_txt_Box {
        margin-top: 0.375rem;
        font-size: 0.875rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #8e8e8e;
        .flexStyle(row, center, flex-start);

        .E_suggest_updateImg_btn {
          cursor: pointer;
          position: absolute;
          left: 0;
          top: 0;
          width: 0;
          height: 0;
          opacity: 0;
        }

        .E_suggest_imgBoxs {
          .flexStyle(row, center, flex-start);
        }

        .E_suggest_imgBox {
          position: relative;
          cursor: pointer;
          margin-right: 0.625rem;
          width: 1.5625rem;
          height: 1.5625rem;
          background: #f8f8f8;
          border: 0.0625rem solid #dddddd;
          border-radius: 0.1875rem;
          .flexStyle(row, center, center);

          img {
            width: 100%;
            max-height: 100%;
          }
        }

        .E_suggest_updateImg {
          .E_suggest_updateImg_closer {
            display: none;
            position: absolute;
            right: 0;
            top: 0;
            transform: translate(50%, -50%);
          }
        }

        .E_suggest_updateImg:hover {
          .E_suggest_updateImg_closer {
            display: block;
          }
        }

        .E_suggest_imgNum {
          margin-left: 0.3125rem;
        }
      }
    }

    .E_suggest_link_method {
      margin-top: 2.8125rem;
    }

    // 联系方式输入框
    .E_suggest_link_method_input {
      width: 100%;
      padding: 1rem;
      box-sizing: border-box;
      margin-top: 1.25rem;
      height: 2.8125rem;
      background: #ffffff;
      border: 1px solid #dddddd;
      border-radius: 0.3125rem;
      outline: none;
    }

    .E_suggest_tips {
      margin-top: 0.9375rem;
      font-size: 0.875rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;

      .E_suggest_kefu {
        display: inline-block;
        cursor: pointer;
        color: #ff4e4a;
        text-decoration: underline;
      }
    }

    .E_suggest_bottom_btn_box {
      margin-top: 2rem;
      .flexStyle(row, center, center);

      .E_suggest_bottom_btn {
        cursor: pointer;
        .flexStyle(row, center, center);
        width: 15.625rem;
        height: 3.125rem;
        background: #ff4e4a;
        border-radius: 0.3125rem;
        font-size: 1.25rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #f6f7fb;
      }

      .E_suggest_bottom_btn:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>